import React from 'react'
import useSearch from '../../../context/search/useSearch'

interface ISearchResultsCollectionsComponent {
  dataSet: DOMStringMap
}

const SearchResultsCollections: React.FC<ISearchResultsCollectionsComponent> = ({dataSet}): JSX.Element => {

  const {langTitle} = dataSet

  const {quickSearchResultsCollections} = useSearch()

  if (quickSearchResultsCollections && !quickSearchResultsCollections.length) return null

  return (
    <React.Fragment>
      <div className={'sf-results sf-results-collections'}>
        {(quickSearchResultsCollections && quickSearchResultsCollections.length) && <React.Fragment>
         
          <div className={'sf-results-collections-items sf-results-loaded'}>
            {langTitle && <div className={'sf-results-collections-title sf-results-title'}>{langTitle}</div>} 
            {quickSearchResultsCollections.map((collection, index) => {
              return (
                <li className={'sf-results-collections-item'} key={index}>
                  <a href={collection.url}>{ collection.title }</a>
                </li>
              )
            })}
          </div>
        </React.Fragment>}
      </div>
    </React.Fragment>
  )
}

export default SearchResultsCollections